import { StoryState } from "Infrastructure/Api/Api";

/** Content is frozen while live — Stream is never updated in place. */
export const canEditStory = (state: StoryState): boolean =>
  state !== StoryState.Live;

/** One live window per story; publish again only after expiry or unpublish (or a first publish of a draft). */
export const canPublishStory = (state: StoryState): boolean =>
  state !== StoryState.Live;

/** Taking down ends the live window early; the story then edits and publishes again like an expired one. */
export const canUnpublishStory = (state: StoryState): boolean =>
  state === StoryState.Live;
